import client from "./client";

const URL = "https://ufoodapi.herokuapp.com";


export const createFavoriteList = async (name,token) => {
  const response = await fetch(`${URL}/favorites`, {
    method: 'POST',
    headers: {
      'Authorization': token.token
    },
    body: new URLSearchParams({
      'name': name
    }),
  })

  if (response.status === 201) {
    return response.json();
  } else {
    return ""
  }
}


export const getFavoritesLists = async (token) => {
  const response = await fetch(`${URL}/favorites?limit=500`, {
    headers: {
      'Authorization': token.token
    },
  })

  return response.json();
}


export const getUserFavoritesLists = async (token) => {
  const response = await fetch(`${URL}/users/${token.id}/favorites?limit=10`, {
    headers: {
      'Authorization': token.token
    },
  })

  return response.json();
}


export const getFavoritesList = async (favoriteId,token) => {
  const response = await fetch(`${URL}/favorites/${favoriteId}`, {
    headers: {
      'Authorization': token.token
    },
  })

  return response.json();
}


export const deleteFavoriteList = async (favoriteId,token) => {
  const response = await fetch(`${URL}/favorites/${favoriteId}`, {
    method: 'DELETE',
    headers: {
      'Authorization': token.token
    },
  })
  if (response.status === 200) {
    return response.json();
  } else {
    return ""
  }
}


export const addRestaurantToFavoriteList = async (listFavoriteId, id,token) => {

  const response = await fetch(`${URL}/favorites/${listFavoriteId}/restaurants`, {
    method: 'POST',
    headers: {
      'Authorization': token.token
    },
    body: new URLSearchParams({
      'id': id
    })
  })

  if (response.status === 200) {
    return response.json();
  } else {
    return ""
  }
}

export const deleteRestaurantFromFavoriteList = async (listFavoriteId, restaurantId,token) => {

  const response = await fetch(`${URL}/favorites/${listFavoriteId}/restaurants/${restaurantId}`, {
    method: 'DELETE',
    headers: {
      'Authorization': token.token
    },
  })
  if (response.status === 200) {
    return response.json();
  } else {
    return ""
  }
}


export const updateFavoriteList = async (listFavoriteId, name, token) => {

  const response = await fetch(`${URL}/favorites/${listFavoriteId}`, {
    method: 'PUT',
    headers: {
      'Authorization': token.token
    },
    body: new URLSearchParams({
      'name': name
    })
  })

  if (response.status === 200) {
    return response.json();
  } else {
    return ""
  }
}

export const getUserFavoritsLists = async (user_id) => {
  return await client.get(`/users/${user_id}/favorites?limit=10)`)
}


